import Vue from "vue";
import * as componentsProsegur from "@/common/components/look/";

const componentsProsegurConst: { [key: string]: unknown } = componentsProsegur;
Object.keys(componentsProsegur).forEach((key: string) => {
  Vue.component(key, componentsProsegurConst[key] as Vue);
});
